import React, { Component } from "react";

import Axios from "axios";

import ReactTable from "react-table";
import { toast } from "react-toastify";

import { Header, Modal, Form, Button, Popup } from "semantic-ui-react";
import PetList from "../Shared/PetList";
import StandingAppointment from "../Forms/StandingAppointment";
import customFilter from "../lib/filters";
import { OptionsContext } from "../OptionsContext";
import _ from "lodash";
import SidebarLayout from "../Shared/SidebarLayout";
import AppointmentStandingPreview from "../Shared/AppointmentStandingPreview";

class StandingAppointments extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pages: -1,
      loading: false,
      selectedStanding: null,
      openStandingModal: false
    };
    this.getAppointments = this.getAppointments.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.onStandingSave = this.onStandingSave.bind(this);
    this.openStandingModal = this.openStandingModal.bind(this);
  }
  componentDidMount() {
    this._isMounted = true;
    this.getAppointments();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  async getAppointments(state, instance) {
    this.setState({ loading: true });
    try {
      let response = await Axios.get("/api/v4/appointments/getAll", {
        params: {
          onlyStandings: true
        }
      });

      if (this._isMounted) {
        if (response.status === 200) {
          this.setState({
            data: response.data.standings,
            pages: response.data.pages
          });
        }
        this.setState({ loading: false });
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to retrieve standing appointments.");
      this.setState({ loading: false });
    }
  }
  onRowClick(state, rowInfo, column) {
    if (this.state.loading === true || !rowInfo) return;
    this.setState({ selectedStanding: rowInfo.original });
  }
  deselectStanding = () => {
    this.setState({ selectedStanding: null });
  };
  onStandingSave() {
    this.getAppointments();
    this.deselectStanding();
    this.closeStandingModal();
  }
  openStandingModal(value) {
    let appointmentFound = _.find(this.state.data, { ID: value });
    this.setState({ openStandingModal: appointmentFound });
  }
  closeStandingModal = () => {
    this.setState({ openStandingModal: false });
  };
  render() {
    const { selectedStanding, data, loading, openStandingModal } = this.state;
    return (
      <SidebarLayout>
        <div>
          {/* Form for editing a standing appointment */}
          <Modal
            size="large"
            onClose={this.closeStandingModal}
            open={openStandingModal !== false}
            closeIcon
          >
            <Modal.Header>Edit Standing Appointment Recurrence</Modal.Header>
            <Modal.Content>
              <StandingAppointment
                appointment={openStandingModal}
                onSave={this.onStandingSave}
              />
            </Modal.Content>
          </Modal>

          <Header as="h2">Standing Appointments</Header>
          <ReactTable
            getTheadThProps={(state, rowInfo, instance) => {
              return {
                className: "standing-appointments-table-" + instance.id
              };
            }}
            data={data}
            filterable
            sortable
            defaultFilterMethod={customFilter}
            defaultSorted={[{ id: "customerId" }]}
            defaultPageSize={window.innerHeight > 1000 ? 25 : 10}
            columns={[
              {
                Header: "",
                accessor: "ID",
                width: 45,
                filterable: false,
                getProps: () => {
                  return {};
                },
                Cell: props => (
                  <Popup
                    basic
                    inverted
                    content="View recurrence details"
                    trigger={
                      <Button
                        fluid
                        size="small"
                        icon="clock"
                        color="blue"
                        onClick={() => this.openStandingModal(props.value)}
                      />
                    }
                  />
                )
              },
              {
                Header: "Customer",
                id: "customerId",
                accessor: data =>
                  data.Customer &&
                  data.Customer.User &&
                  `${data.Customer.User.firstName} ${data.Customer.User.lastName}`
              },
              {
                Header: "Title",
                id: "title",
                accessor: data => {
                  return data.Standing ? data.Standing.title : "";
                },
                minWidth: 100
              },
              {
                Header: "Preferred Stylist",
                headerClassName: "dropdown-filter",
                id: "employeeId",
                accessor: data => {
                  let fullName =
                    data && data.Employee && data.Employee.User
                      ? `${data.Employee.User.firstName || ""} ${data.Employee
                          .User.lastName || ""}`
                      : `${data.EmployeeFirstName ||
                          ""} ${data.EmployeeLastName || ""}`;
                  return fullName;
                },
                Filter: ({ filter, onChange }) => (
                  <Form size="small">
                    <Form.Select
                      className="filter-select"
                      fluid
                      clearable
                      search
                      name="employeeId"
                      placeholder="Select Stylist"
                      options={this.props.stylists.map(stylist => {
                        let fullName =
                          stylist && stylist.User
                            ? `${stylist.User.firstName || ""} ${stylist.User
                                .lastName || ""}`
                            : `${stylist.EmployeeFirstName ||
                                ""} ${stylist.EmployeeLastName || ""}`;
                        return {
                          key: stylist.ID,
                          value: fullName,
                          text: fullName
                        };
                      })}
                      value={filter ? filter.value : null}
                      onChange={(event, { name, value }) => onChange(value)}
                    />
                  </Form>
                )
              },
              {
                Header: "Pets",
                id: "pets",
                accessor: data =>
                  data.Estimate &&
                  data.Estimate.EstimatePets &&
                  data.Estimate.EstimatePets.map(
                    petEstimate => petEstimate.Pet
                  ),
                Cell: props => <PetList includeDetails pets={props.value} />
              },
              {
                Header: "Last Comment",
                id: "lastComment",
                accessor: data => {
                  if (
                    data.CommentGroup &&
                    data.CommentGroup.Comments &&
                    data.CommentGroup.Comments.length > 0
                  ) {
                    let lastComment = _.maxBy(
                      data.CommentGroup.Comments,
                      "DateAdded"
                    );
                    return lastComment.comment;
                  }
                  return "";
                },
                filterable: false,
                minWidth: 250
              }
            ]}
            loading={loading}
            className="-striped -highlight standing-appointments-table"
            getTdProps={(state, rowInfo, column) => {
              if (rowInfo && rowInfo.original.ID != null) {
                let classNames = " ";

                // Set a classname based on status
                let appointmentStatus = _.find(this.props.statuses, {
                  ID: rowInfo.original.statusId
                });
                if (appointmentStatus) {
                  classNames =
                    classNames +
                    " appointment-status-" +
                    appointmentStatus.status;
                }
                if (
                  selectedStanding &&
                  rowInfo.original.ID === selectedStanding.ID
                ) {
                  classNames = classNames + " selected-row";
                }

                if (column.Header !== "") {
                  let style = {};
                  style.cursor = "pointer";

                  return {
                    onClick: () => this.onRowClick(state, rowInfo, column),
                    style: style,
                    className: classNames
                  };
                }
                return { className: classNames };
              }
              return {};
            }}
          />
        </div>
        <AppointmentStandingPreview
          appointment={selectedStanding}
          key={selectedStanding ? selectedStanding.ID : undefined}
          onAppointmentAction={this.onStandingSave}
          estimateId={
            selectedStanding && selectedStanding.Estimate
              ? selectedStanding.Estimate.ID
              : null
          }
        />
      </SidebarLayout>
    );
  }
}

StandingAppointments.defaultProps = {
  onRowClick: null,
  statuses: [],
  stylists: []
};

export default props => (
  <OptionsContext.Consumer>
    {({ statuses, stylists }) => (
      <StandingAppointments
        {...props}
        statuses={statuses}
        stylists={stylists}
      />
    )}
  </OptionsContext.Consumer>
);
